import moment from 'moment';

export const requestTimePassed = (date: string | Date, time: string | Date) => {
	const timeDate = new Date(time);
	const startDate = moment(new Date(date)).set({ hour: timeDate.getHours(), minute: timeDate.getMinutes() });
	const now = new Date();
	return startDate.isBefore(now);
}